import React from "react";
import styled from "styled-components";
import { color, spacing, palette, fontWeight } from "@conserveit/blocks";

const Container = styled.div`
  color: ${color.theme.typography.ink};
`;

const H1 = styled.h1`
  margin: 0 0 ${spacing.loose};
  font-size: 28px;
  line-height: 32px;
`;

const H2 = styled.h2`
  margin: 0 0 ${spacing.extraTight};
  font-size: 19px;
  line-height: 22px;
`;

const SubH2 = styled(H2)`
  margin: 0 0 ${spacing.extraLoose};
  line-height: 24px;
  font-weight: ${fontWeight.normal};
  color: ${palette.neutral7};
`;

const H3 = styled.h3`
  margin: 0 0 ${spacing.tight};
  font-size: 12px;
  line-height: 16px;
  font-weight: ${fontWeight.bold};
  text-transform: uppercase;
`;

const Message = styled.p`
  margin: 0 0 ${spacing.loose};
  font-size: 14px;
  line-height: 20px;
  color: ${palette.neutral7};
`;

const SummaryMessage: React.FC<{ month: string }> = ({ month }) => (
  <Container>
    <H1>{month}, at a glance</H1>
    <H2>Actions</H2>
    <SubH2>Keep track of your improvement month to month.</SubH2>
    <H3>What are actions?</H3>
    <Message>
      Actions are opportunities for improvement identified by our analytics
      platform. Resolving Actions will help increase performance, efficiency
      and/or comfort of the site. The Monthly Summary helps you track your
      progress against recommended improvements.
    </Message>
  </Container>
);

export default SummaryMessage;
